export { default } from "./FacetTags.js";
